import { useState } from "react";
import ShareIcon from "@mui/icons-material/Share";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, IconButton, Tooltip, Snackbar, Alert } from "@mui/material";

const ShareActions = ({
  title = "NearbyGuide",
  text = "Discover trusted places and services.",
  url,
}) => {
  const pageUrl = url || window.location.href;
  const [open, setOpen] = useState(false);

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url: pageUrl });
      } catch {}
    }
  };

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(pageUrl);
    setOpen(true);
  };

  return (
    <>
      {/* SHARE ICONS */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: 12, md: 20 },
          right: { xs: 12, md: 24 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 1.2,
          zIndex: 5,
        }}
      >
        <Tooltip title="Share">
          <IconButton onClick={handleNativeShare} sx={glassBtn}>
            <ShareIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="WhatsApp">
          <IconButton
            component="a"
            href={`https://wa.me/?text=${encodeURIComponent(
              `${text} ${pageUrl}`,
            )}`}
            target="_blank"
            rel="noopener"
            sx={whatsappBtn}
          >
            <WhatsAppIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="LinkedIn">
          <IconButton
            component="a"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
              pageUrl,
            )}`}
            target="_blank"
            rel="noopener"
            sx={linkedinBtn}
          >
            <LinkedInIcon fontSize="small" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Copy link">
          <IconButton onClick={handleCopyLink} sx={copyBtn}>
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* SNACKBAR */}
      <Snackbar
        open={open}
        autoHideDuration={2200}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ borderRadius: 2 }}
        >
          Link copied to clipboard
        </Alert>
      </Snackbar>
    </>
  );
};

export default ShareActions;


const baseBtn = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  boxShadow: "0 4px 14px rgba(0,0,0,0.18)", // ✅ visibility boost
};

const glassBtn = {
  ...baseBtn,
  bgcolor: "rgba(255,255,255,0.35)", // ✅ stronger contrast
  color: "#0A272D",
  backdropFilter: "blur(8px)",
  border: "1px solid rgba(255,255,255,0.45)",
  "&:hover": {
    bgcolor: "rgba(255,255,255,0.5)",
  },
};

const copyBtn = {
  ...glassBtn,
};

const whatsappBtn = {
  ...baseBtn,
  bgcolor: "#25D366",
  color: "#fff",
  "&:hover": { bgcolor: "#1EBE5D" },
};

const linkedinBtn = {
  ...baseBtn,
  bgcolor: "#0A66C2",
  color: "#fff",
  "&:hover": { bgcolor: "#004182" },
};
